export const bankPartner = {
  name: "Zolve",
  websiteLink: "https://bit.ly/LeapFin24",
};
